<template>
  <div class="row" v-if="setting">
    <div class="col-md-12">
      <div class="card card-default card-shadow mt-4">
        <div class="card-header">{{ translate('settings.manage-time-slots.title') }}</div>

        <div class="card-body">

          <div class="alert alert-success mt-0" v-if="updateSettingsDatesForm.successful">
            <i class="fas fa-check-circle"></i> {{ translate('settings.manage-time-slots.success') }}
          </div>

          <FullCalendar ref="fullCalendar" :options="calendarOptions" />
        </div>
      </div>
    </div>
    <!--        <div class="col-md-4">-->
    <!--            <div class="card card-default card-shadow mt-4">-->
    <!--                <div class="card-header">Manage Selected Time Slots</div>-->

    <!--                <div class="card-body">-->
    <!--                    <div class="alert alert-success" v-if="updateSettingsDatesForm.successful">-->
    <!--                        Time Slots Updated Successfully-->
    <!--                    </div>-->
    <!--                    <form role="form">-->
    <!--                        <div class="form-group row">-->
    <!--                            <label for="slots" class="col-md-4 col-form-label text-md-right">Slots</label>-->

    <!--                            <div class="col-md-6">-->
    <!--                                <input id="slots"-->
    <!--                                       type="text"-->
    <!--                                       class="form-control"-->
    <!--                                       name="slots"-->
    <!--                                       v-model.number="updateSettingsDatesForm.slots"-->
    <!--                                       max="10"-->
    <!--                                       min="0"-->
    <!--                                       :class="{'is-invalid': updateSettingsDatesForm.errors.has('slots')}"-->
    <!--                                       required autofocus>-->

    <!--                                <span class="invalid-feedback"-->
    <!--                                      role="alert"-->
    <!--                                      v-if="updateSettingsDatesForm.errors.has('slots')">-->
    <!--                                                <strong>{{ updateSettingsDatesForm.errors.get('slots') }}</strong>-->
    <!--                                            </span>-->
    <!--                            </div>-->
    <!--                        </div>-->

    <!--                        <div class="form-group row">-->
    <!--                            <div class="form-check col-md-4 text-md-right">-->
    <!--                                <label class="form-check-label form-check-toggle">-->
    <!--                                    <input class="form-check-input"-->
    <!--                                           type="checkbox"-->
    <!--                                           name="availability"-->
    <!--                                           v-model="updateSettingsDatesForm.whole_day"-->
    <!--                                           @click="updateSettingsDatesForm.time = null"/><span></span>-->
    <!--                                </label>-->
    <!--                            </div>-->
    <!--                            <label class="col-md-6 col-form-label text-md-left">Manage Whole Day</label>-->
    <!--                        </div>-->

    <!--                        <button type="submit"-->
    <!--                                class="btn btn-primary"-->
    <!--                                @click.prevent="updateSettingsDates"-->
    <!--                                :disabled="updateSettingsDatesForm.busy">-->
    <!--                            Update-->
    <!--                        </button>-->
    <!--                    </form>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import '@fullcalendar/core/locales/de';
import rrulePlugin from '@fullcalendar/rrule';
import {RRule, RRuleSet, rrulestr} from 'rrule';

export default {
  props: ['setting'],

  components: {
    FullCalendar,
  },

  /**
   * The component's data.
   */
  data () {
    return {
      updateSettingsDatesForm: new AppForm({
        dates: [],
        slots: 10,
        whole_day: true,
      }),

      calendarOptions: {
        plugins: [
          timeGridPlugin,
          rrulePlugin,
          interactionPlugin,
        ],
        initialView: 'timeGridWeek',
        slotDuration: '01:00:00',
        events: [],
        eventClick: this.handleEventClick,
        contentHeight: 1000,
        selectable: true,
        locale: App.locale,
        allDaySlot: false,
        slotMinTime: '08:00',
        slotMaxTime: '20:00',
        slotLabelInterval: '0',
        firstDay: 1,
        slotLabelFormat: {
          hour: 'numeric',
          omitZeroMinute: true,
          meridiem: 'short'
        },
        expandRows: true,
        height: '710px',
        eventTimeFormat: {
          hour: '2-digit',
          meridiem: true
        },
        displayEventEnd: false
      }
    };
  },

  watch: {
    setting: function (setting) {
      this.initCalendar();
    }
  },

  computed: {
    minDate () {
      return this.setting.available_from ? this.setting.available_from : '';
    },

    maxDate () {
      return this.setting.available_to ? this.setting.available_to : '';
    },

    weekdays () {
      return JSON.parse(this.setting.weekdays);
    }
  },

  /**
   * Bootstrap the component.
   */
  mounted () {
    this.initCalendar();
  },

  methods: {
    updateSettingsDates () {
      App.put('/api/settings/1/dates', this.updateSettingsDatesForm)
        .then(() => {
          this.updateSettingsDatesForm.changed = false;
          this.$parent.$emit('updateSettings');
        });
    },

    handleEventClick (info) {
      let date = moment(info.event.start).format('YYYY-MM-DD hh:mm:ss');

      if (this.updateSettingsDatesForm.dates.includes(date)) {
        $(info.el).removeClass('selected');

        let index = this.updateSettingsDatesForm.dates.indexOf(date);
        if (index > -1) {
          this.updateSettingsDatesForm.dates.splice(index, 1);
        }
      } else {
        $(info.el).addClass('selected');
        this.updateSettingsDatesForm.dates.push(date);
      }
    },

    syncDate (date) {
      let dateObject = moment(date);
      let formattedDate = dateObject.format('YYYY-MM-DD');
      let weekDay = dateObject.weekday().toString();
      this.updateSettingsDatesForm.changed = true;

      if (!this.isAvailable(dateObject)) {
        return;
      }

      if (this.weekdays.includes(weekDay)) {
        if (this.updateSettingsDatesForm.blocked_dates.includes(formattedDate)) {
          let index = this.updateSettingsDatesForm.blocked_dates.indexOf(formattedDate);

          if (index > -1) {
            this.updateSettingsDatesForm.blocked_dates.splice(index, 1);
          }
        } else {
          this.updateSettingsDatesForm.blocked_dates.push(formattedDate);
        }
      } else {
        if (this.updateSettingsDatesForm.unblocked_dates.includes(formattedDate)) {
          let index = this.updateSettingsDatesForm.unblocked_dates.indexOf(formattedDate);

          if (index > -1) {
            this.updateSettingsDatesForm.unblocked_dates.splice(index, 1);
          }
        } else {
          this.updateSettingsDatesForm.unblocked_dates.push(formattedDate);
        }
      }
    },

    isAvailable (date) {
      if (this.maxDate === '' && this.minDate === '') {
        return true;
      }

      return date.isSameOrBefore(this.maxDate, 'day') && date.isSameOrAfter(this.minDate, 'day');
    },

    initCalendar () {
      let self = this;

      let maxTime = '00:00';
      let minTime = '23:00';

      for (const [key, value] of Object.entries(this.weekdays)) {
        if (maxTime < value.end) {
          maxTime = value.end;
        }

        if (minTime > value.start) {
          minTime = value.start;
        }
      }

      this.calendarOptions.slotMinTime = minTime;
      this.calendarOptions.slotMaxTime = maxTime;
      this.calendarOptions.events = [];

      for (const [key, value] of Object.entries(self.weekdays)) {
        let availableSlotsRule = new RRuleSet();
        let breakHoursRange = _.range(self.setting.break_start.substr(0, 2), self.setting.break_end.substr(0, 2));
        let byHourRange = _.range(value.start.substr(0, 2), value.end.substr(0, 2)).filter(hour => !breakHoursRange.includes(hour));

        let rruleOptions = {
          freq: RRule.HOURLY,
          byweekday: key.substr(4),
          byhour: byHourRange,
        };

        let minBookingNoticeDate = moment().add(self.setting.min_booking_notice, 'days').format('YYYY-MM-DD');
        if (self.setting.available_to && self.setting.available_from) {
          rruleOptions.until = new Date(self.maxDate + 'T00:00:00');

          if (moment(self.minDate).isBefore(minBookingNoticeDate)) {
            rruleOptions.dtstart = new Date(minBookingNoticeDate + 'T00:00:00');
          } else {
            rruleOptions.dtstart = new Date(moment(self.minDate).add(self.setting.min_booking_notice, 'days').format('YYYY-MM-DD') + 'T00:00:00');
          }
        } else {
          rruleOptions.dtstart = new Date(minBookingNoticeDate + 'T00:00:00');
        }

        availableSlotsRule.rrule(new RRule(rruleOptions));

        self.calendarOptions.events.push({
          duration: '01:00',
          color: 'white',
          borderColor: '#343a40', // #ddd
          textColor: '#343a40', // #ddd
          rrule: availableSlotsRule.toString()
        });
      }
    }
  },
};
</script>

<style scoped>
.fc-timegrid-event.selected {
    background-color: #00bf8f !important;
}

.fc-timegrid-event.selected .fc-event-main {
    color: white !important;
}
</style>
